<div class="absolute left-0 top-0 h-16 w-16" style="z-index: 9999">
    <div class="absolute transform -rotate-45 bg-red-600 text-center text-white font-semibold py-1 left-[-34px] top-[32px] w-[170px]">
        {{ title }}
    </div>
</div>